module.exports = __webpack_public_path__ + "img/bob.4a8dc524.gif";